// Shared source of truth for the storefront's product-family navigation.
//
// The nav "Frameworks" dropdown, the mobile nav's nested group, and the
// footer "Frameworks" / "Skills for Claude" columns all read from this one
// list so the two products (and their skills-only tiers) can never drift
// out of sync across surfaces — the exact failure this storefront had
// before, where the nav pointed only at the ads framework and the footer
// omitted email-skills.

import { siteConfig } from "~/lib/config/site"

export type FrameworksMenuGroup = "overview" | "frameworks" | "skills"

export interface FrameworksMenuItem {
  /** Visible label. */
  name: string
  href: string
  /** One-line "what is this" shown in the desktop dropdown rows. */
  description: string
  /** Which footer/menu cluster the item belongs to. */
  group: FrameworksMenuGroup
  /** Icon glyph key the desktop dropdown maps to an inline SVG. */
  icon: "grid" | "film" | "mail" | "sparkles"
}

export const FRAMEWORKS_MENU: readonly FrameworksMenuItem[] = [
  {
    name: "Overview",
    href: siteConfig.baseLinks.frameworks,
    description: "Both frameworks, side by side",
    group: "overview",
    icon: "grid",
  },
  {
    name: "Ads Framework",
    href: siteConfig.baseLinks.adsFramework,
    description: "Remotion video ads — $199",
    group: "frameworks",
    icon: "film",
  },
  {
    name: "Email Framework",
    href: siteConfig.baseLinks.emailFramework,
    description: "React Email lifecycle templates — $149",
    group: "frameworks",
    icon: "mail",
  },
  {
    name: "Ads Skills",
    href: siteConfig.baseLinks.adsSkills,
    description: "Skills-only for Claude & Claude Code — $99",
    group: "skills",
    icon: "sparkles",
  },
  {
    name: "Email Skills",
    href: siteConfig.baseLinks.emailSkills,
    description: "Skills-only for Claude & Claude Code — $79",
    group: "skills",
    icon: "sparkles",
  },
] as const

export const frameworksMenuByGroup = (
  group: FrameworksMenuGroup,
): readonly FrameworksMenuItem[] => FRAMEWORKS_MENU.filter((i) => i.group === group)
